// src/components/student/sat/StudentSATDiagnosticList.js
import React, { useState, useEffect } from 'react';
import { auth, db } from '../../../firebaseConfig';
import { collection, getDocs, query, where } from "firebase/firestore";

// --- STYLES ---
const styles = {
  // Kept your original styles, but we don't need 'page', 'header', 'nav' anymore.
  // I have cleaned them up to only what this specific list component needs.
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px', padding: '20px' },
  card: { backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '20px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' },
  cardTitle: { fontSize: '16px', fontWeight: 700, color: '#111827', marginBottom: '8px' },
  cardMeta: { fontSize: '13px', color: '#6b7280', marginBottom: '16px' },
  statusBadge: (status) => {
    const colors = {
      locked: { bg: '#f3f4f6', text: '#6b7280', label: 'Locked' },
      unlocked: { bg: '#eff6ff', text: '#2563eb', label: 'Ready to Start' },
      finished: { bg: '#dcfce7', text: '#166534', label: 'Finished' }
    };
    const c = colors[status] || colors.locked;
    return { display: 'inline-block', padding: '4px 10px', borderRadius: '99px', backgroundColor: c.bg, color: c.text, fontSize: '11px', fontWeight: 700, textTransform: 'uppercase' };
  },
  startBtn: { width: '100%', padding: '10px', marginTop: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#2563eb', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '13px' },
  disabledBtn: { width: '100%', padding: '10px', marginTop: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#f3f4f6', color: '#9ca3af', fontWeight: 500, cursor: 'not-allowed', fontSize: '13px' },

};

export default function StudentSATDiagnosticList({ onStartTest }) {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!auth.currentUser) return;
      try {
        // 1. Fetch All Tests
        const testsSnap = await getDocs(collection(db, "sat_diagnostic_tests"));
        const allTests = testsSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        // 2. Fetch Student Access
        const accessQ = query(
          collection(db, "student_test_access"), 
          where("studentId", "==", auth.currentUser.uid)
        );
        const accessSnap = await getDocs(accessQ);
        
        const accessMap = {};
        accessSnap.forEach(d => {
          const data = d.data();
          accessMap[data.testId] = data;
        });

        // 3. Merge Data
        const merged = allTests.map(t => {
          const access = accessMap[t.id] || {};
          let status = 'locked';
          if (access.finished) status = 'finished';
          else if (access.unlocked) status = 'unlocked';
          
          return { ...t, status };
        });

        setTests(merged);
      } catch (err) {
        console.error("Error loading tests:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div style={{ padding: 20 }}>Loading tests...</div>;

  return (
    <>
      <div style={styles.grid}>
        {tests.map(test => (
          <div key={test.id} style={styles.card}>
            <div style={{display:'flex', justifyContent:'space-between', marginBottom: 10}}>
              <span style={styles.statusBadge(test.status)}>{test.status === 'unlocked' ? 'Ready' : test.status}</span>
            </div>
            <h3 style={styles.cardTitle}>{test.id}</h3>
            <p style={styles.cardMeta}>Full Adaptive Diagnostic</p>
            
            {test.status === 'unlocked' ? (
              <button style={styles.startBtn} onClick={() => onStartTest(test.id)}>Start Test</button>
            ) : test.status === 'finished' ? (
              <button style={styles.disabledBtn} disabled>Finished</button>
            ) : (
              <button style={styles.disabledBtn} disabled>Locked</button>
            )}
          </div>
        ))}
        {tests.length === 0 && <p style={{color:'#6b7280'}}>No tests found.</p>}
      </div>


    </>
  );
};